import { Box, Tooltip, Typography } from '@mui/material'

const SegmentMiniRules = ({
    tagText,
    isRefundable,
    tooltipContent
}: {
    tagText: string
    isRefundable: boolean
    tooltipContent: React.ReactNode
}) => {
    return (
        <Tooltip
            title={tooltipContent}
            arrow
            placement="bottom"
            slotProps={{
                tooltip: {
                    sx: {
                        bgcolor: 'rgba(0, 0, 0, 0.9)',
                        '& .MuiTooltip-arrow': {
                            color: 'rgba(0, 0, 0, 0.9)'
                        },
                        maxWidth: 410
                    }
                }
            }}
        >
            <Box
                sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 0.4,
                    backgroundColor: isRefundable ? 'success.light' : 'error.light',
                    padding: '3px 8px',
                    borderRadius: '8px',
                    border: '1px solid',
                    borderColor: isRefundable ? 'success.main' : 'error.main',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: isRefundable ? 'success.medium' : 'error.medium'
                    }
                }}
            >
                <Typography
                    variant="caption"
                    sx={{
                        fontSize: 12,
                        fontWeight: 500,
                        color: isRefundable ? 'success.main' : 'error.main',
                        textTransform: 'uppercase',
                        letterSpacing: '0.4px',
                        lineHeight: 1.2,
                        cursor: 'pointer'
                    }}
                >
                    {tagText}
                </Typography>

                {/* <InfoOutlinedIcon
                    sx={{
                        fontSize: 12,
                        color: isRefundable ? 'success.main' : 'error.main'
                    }}
                /> */}
            </Box>
        </Tooltip>
    )
}

export default SegmentMiniRules
